document.addEventListener('DOMContentLoaded', () => {
    const svg = document.querySelector('.anim_hero svg');
    if (!svg) return;

    const paths = Array.from(svg.querySelectorAll('g path'));
    const colors = ['#50AFE3', '#F04E4E', '#2C2B67'];
    const highlightCount = 40;

    function randomizePaths() {
        // Reset wszystkich path
        paths.forEach(path => path.setAttribute('fill', ''));

        // Wybieramy losowe 40 path
        const shuffled = paths.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, highlightCount);

        // Nadaj losowy kolor z tablicy
        selected.forEach(path => {
            const color = colors[Math.floor(Math.random() * colors.length)];
            path.setAttribute('fill', color);
        });
    }

    // Pierwsze wywołanie
    randomizePaths();

    // Powtarzaj co 3 sekundy
    setInterval(randomizePaths, 3000);
});



document.addEventListener('DOMContentLoaded', () => {
    const svg = document.querySelector('.Footer__pattern svg');
    if (!svg) return;

    const paths = Array.from(svg.querySelectorAll('g path'));
    const colors = ['#50AFE3', '#F04E4E', '#2C2B67'];
    const highlightCount = 40;

    function randomizePaths() {
        // Reset wszystkich path
        paths.forEach(path => path.setAttribute('fill', ''));

        // Wybieramy losowe 40 path
        const shuffled = paths.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, highlightCount);

        // Nadaj losowy kolor z tablicy
        selected.forEach(path => {
            const color = colors[Math.floor(Math.random() * colors.length)];
            path.setAttribute('fill', color);
        });
    }

    // Pierwsze wywołanie
    randomizePaths();

    // Powtarzaj co 3 sekundy
    setInterval(randomizePaths, 3000);
});
